import { Copy, MoreVertical, Trash2 } from "lucide-react";

import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItemLabel,
  MenuPopover,
  MenuTrigger,
} from "@/components/menu";

import type { BaseRequest, TableConfig } from "../../../types/tables";

import {
  brandCell,
  createdByCell,
  dateCell,
  nameCell,
  requestDesignTypeCell,
} from "../../helpers/commonCells";

// Drafts Tab Configuration with Action column for delete
export const draftsTableConfig: TableConfig<BaseRequest> = {
  columns: [
    {
      accessor: "name",
      cellRenderer: nameCell,
      header: "Name",
      key: "name",
      sortable: true,
      width: 260,
    },
    {
      accessor: "brand",
      cellRenderer: brandCell,
      header: "Brand",
      key: "brand",
      sortable: true,
      width: 200,
    },
    {
      accessor: "createdBy",
      cellRenderer: createdByCell,
      header: "Created by",
      key: "createdBy",
      sortable: true,
      width: 140,
    },
    {
      accessor: "createdAt",
      cellRenderer: dateCell,
      header: "Created date",
      key: "createdAt",
      sortable: true,
      width: 140,
    },
    {
      accessor: "requestType",
      cellRenderer: requestDesignTypeCell,
      header: "Request/Design type",
      key: "requestType",
      sortable: true,
      width: 180,
    },
    {
      accessor: "id",
      cellRenderer: (_value, row, customProps) => (
        <MenuTrigger>
          <MenuButton
            className="text-text-tertiary hover:text-text-secondary p-2"
            noIndicator
            variant="tertiary"
          >
            <MoreVertical size={16} />
          </MenuButton>
          <MenuPopover>
            <Menu
              onAction={(key) => {
                if (key === "delete" && customProps?.onDirectDelete) {
                  // Direct action - immediately trigger delete modal
                  (customProps.onDirectDelete as (id: number) => void)(row.id);
                } else if (
                  key === "duplicate" &&
                  customProps?.onDirectDuplicate
                ) {
                  // Direct action - immediately trigger duplicate modal
                  (customProps.onDirectDuplicate as (id: number) => void)(
                    row.id,
                  );
                }
              }}
            >
              <MenuItem id="duplicate">
                <Copy data-ui="icon" size={16} />
                <MenuItemLabel>Duplicate request</MenuItemLabel>
              </MenuItem>
              <MenuItem destructive id="delete">
                <Trash2 data-ui="icon" size={16} />
                <MenuItemLabel>Delete</MenuItemLabel>
              </MenuItem>
            </Menu>
          </MenuPopover>
        </MenuTrigger>
      ),
      header: "Action",
      key: "action",
      sortable: false,
      width: 80,
    },
  ],
  defaultSort: {
    column: "createdAt",
    direction: "desc",
  },
  // No title as per requirements
  enableSorting: true,
  id: "drafts-requests",
};
